import styled from 'styled-components';

export const StyledPage = styled.div`
  .how-it-works-content {
    color: #0b1a30;
    h2,
    h3,
    h4 {
      line-height: 1.38;
      padding-bottom: 8px;
      margin-bottom: 0;
      font-weight: 500;
    }
    h2 {
      font-size: 26px;
    }
    h3 {
      font-size: 20px;
    }
    h4 {
      font-size: 18px;
    }
    figure {
      margin: 0;
    }
    p:has(> img),
    div:has(> img),
    p:has(> picture),
    figure:has(> img),
    div:has(> picture) {
      max-width: 476px;
      background-color: #f4f4f4;
      border-radius: 12px;
      padding: 20px;
      img {
        width: 100% !important;
        height: auto !important;
        border-radius: 12px;
        object-fit: cover;
      }
    }
  }
  .media {
    max-width: 476px;
    border-radius: 12px;
    overflow: hidden;
  }
`;
